// The view controls the logbook list pages share: the Entries/Trips toggle
// (only where the host offers both views -- the view itself lives in the
// host's URL, see useLogbookViewPrefs' header) and the Show notes / Show photos
// switches (persisted, useLogbookViewPrefs).
//
// Show photos is gated on `showPhotosToggle`, the `showViewToggle` idiom above:
// only a host that actually loads photos passes the handler, so a page that
// mounts no useEntryPhotos can't grow a switch that does nothing. All three
// list pages pass it today; the gate stays because the switch has to be able to
// answer for a read that is happening, and a fourth host is free not to make
// one.

import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Form from 'react-bootstrap/Form';

export function LogbookViewControls({
  view,
  onViewChange,
  showViewToggle,
  showNotes,
  onShowNotesChange,
  showPhotosToggle,
  showPhotos,
  onShowPhotosChange,
}) {
  return (
    <div className="d-flex justify-content-center align-items-center flex-wrap gap-3 mb-3">
      {showViewToggle && (
        <ButtonGroup size="sm" aria-label="View">
          <Button
            variant={view === 'entries' ? 'secondary' : 'outline-secondary'}
            aria-pressed={view === 'entries'}
            onClick={() => onViewChange('entries')}
          >
            Entries
          </Button>
          <Button
            variant={view === 'trips' ? 'secondary' : 'outline-secondary'}
            aria-pressed={view === 'trips'}
            onClick={() => onViewChange('trips')}
          >
            Trips
          </Button>
        </ButtonGroup>
      )}
      <Form.Check
        type="switch"
        id="logbook-show-notes"
        label="Show notes"
        checked={showNotes}
        onChange={(e) => onShowNotesChange(e.target.checked)}
      />
      {showPhotosToggle && (
        // `label` is what gives the switch its accessible name -- nothing else
        // may go inside that prop or getByLabelText stops finding it.
        <Form.Check
          type="switch"
          id="logbook-show-photos"
          label="Show photos"
          checked={showPhotos}
          onChange={(e) => onShowPhotosChange(e.target.checked)}
        />
      )}
    </div>
  );
}

export default LogbookViewControls;
